export const splitNameFromFullName = (fullName) => {
  const [firstName, ...lastName] = fullName.split(" ");
  return [firstName, lastName.join(" ")];
};

export const getFullName = (user) => {
  return `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
};
